module.exports = __webpack_public_path__ + "img/emo_29.3d4ee858.gif";